// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_sbom.actions.go

export const BULK_UPLOAD_SBOM = "mondoo.policy.Sbom.BulkUploadSbom";
